import AuthModal from './AuthModal';
import EmailModal from './EmailModal/EmailModal';
import WalletListModal from './WalletListModal/WalletListModal';
import GoogleLoginWideButton from './WideButtons/GoogleLoginWideButton';
import EmailLoginWideButton from './WideButtons/EmailLoginWideButton';
import ButtonGroup from './ButtonGroup';

type ClassesProps = {
  modal?: string;
  container?: string;
};

interface Props {
  classes?: ClassesProps;
  open: boolean;
  onClose?: () => void;
  closable?: boolean;
  returnTo?: string;
  emailVerificationReturnTo?: string;
}

export default function EmailAndGoogleRegisterModal({
  classes = {},
  open,
  onClose = () => {},
  closable = true,
  returnTo,
  emailVerificationReturnTo,
}: Props) {
  return (
    <AuthModal
      modalClassName={classes.modal}
      className={classes.container}
      open={open}
      onClose={onClose}
      closable={closable}
    >
      <ButtonGroup type="wide">
        <GoogleLoginWideButton returnTo={returnTo} />
        <EmailLoginWideButton />
      </ButtonGroup>
      <WalletListModal />
      <EmailModal defaultForm="register" returnTo={emailVerificationReturnTo} />
    </AuthModal>
  );
}
